require('./soundcite');

const SoundCite = window.soundcite;
delete window.soundcite;

export default SoundCite;
